import React from 'react';
import { observer } from 'mobx-react';

import { CHECKOUT_STATUS } from '../../models/Checkout';
import { CheckoutCard, BUTTON_TYPES } from '../../common/checkout-card';
import { CheckoutStore } from '../../stores/CheckoutStore';
import { WindowHelper } from '../../helpers/WindowHelper';
import styles from './CheckoutSuccess.css';

const printPage = (_, buttonType) => {
  if (buttonType === BUTTON_TYPES.PRINT) {
    WindowHelper.print();
  }
};

const CheckoutSuccess = () => {
  const buttonTypes = [];
  if (CheckoutStore.finishedCheckout.status === CHECKOUT_STATUS.CONFIRMED
    && WindowHelper.printEnabled()) {
    buttonTypes.push(BUTTON_TYPES.PRINT);
  }
  return (
    <div className={styles.container}>
      <CheckoutCard
        isPageMyShoppins={false}
        buttonTypes={buttonTypes}
        className={styles.checkoutCard}
        checkout={CheckoutStore.finishedCheckout}
        onButtonClick={printPage}
      />
    </div>
  );
};

const ObservedCheckoutSuccess = observer(CheckoutSuccess);

export { ObservedCheckoutSuccess as CheckoutSuccess };



// WEBPACK FOOTER //
// ./src/pages/checkout-success/CheckoutSuccess.jsx